import React from 'react';
import { Icon, Label } from 'semantic-ui-react';
import styled from 'styled-components';

// Storybook reference: https://ui-standard.hackhub.com/?path=/story/event-styleguide-symbols--symbols

const SymbolContainer = styled.span`
    width: 60px;
    height: 60px;
    display:inline-flex;
    border: ${(props) => (props.hasBorder ? '3px solid #D9E1E7' : 'none')};
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    margin: 0.1em;

    i {
        color: ${(props) => (props.gray ? '#676767' : '#0094FB')};
        position: relative;
    }
`;

const EnvelopeSymbolContainer = styled(SymbolContainer)`
&& {
    width: 40px;
    height: 40px;
    border: 1px solid ${props => props.color};
    cursor: pointer;

    border-radius: 50%;
    i {
        color: ${(props) => props.color};
        margin: 0;
    }
}    
`;

const CheckSymbolContainer = styled(SymbolContainer)`
  i {
      color: ${(props) => (props.color ? props.color : '#11AA66')}
  }
`;

const LoadSymbolContainer = styled(SymbolContainer)`
    i {
        font-size: 1.5em;
        width: 15px;
        height: 15px;
        position: relative;
        border-radius: 50%;
    }

  i.arrowDown {
    background-color:#EE6164;
  }

  i.arrowDown:before {
    content: '\f358';
    color: #D8ADAE;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  i.arrowUp {
      background-color: #48DDAD;
  }

  i.arrowUp:before {
      content: '\f35b';
      color: #A3EED6;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
  }
`;

const BellWrapper = styled.div`
  width: 28px;
  height: 28px;
  position: relative;
  display:inline-flex;
  justify-content: center;
  align-items: center;

    div {
        display:inline-flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

  i {
    color: #676767;
  }

  .ui.circular.label {
    width: 18px;
    height: 18px;
    min-width: 1em ;
    min-height: 1em;
    font-size: 9px;
    color: #FFFFFF;
    background-color: #FF6666;
  }
`;

const getSymbolClass = (iconName) => {
  switch (iconName) {
    case 'calendar':
      return 'calendar minus';
    case 'bookmark':
      return 'bookmark';
    case 'linkedin':
      return 'linkedin';
    case 'twitter':
      return 'twitter';
    case 'facebook':
      return 'facebook f';
    case 'instagram':
      return 'instagram';
    case 'notification':
      return 'bell outline';
    case 'comment':
      return 'comment alternate outline';
    case 'edit':
      return 'edit outline';
    case 'github':
      return 'github';
    case 'check':
      return 'check circle';
    case 'youtube':
      return 'youtube';
    case 'globe':
      return 'globe';
    case 'upload':
      return 'upload';
    case 'heart':
      return 'heart';
    case 'arrowUp':
      return 'arrow alternate circle up';
    case 'arrowDown':
      return 'arrow alternate circle down';
    case 'envelope':
      return 'envelope outline';
    default:
      return 'heart';
  }
};


export const Symbol = (
  {
    iconName, notification, hasBorder, color
  }) => {
  const symbolClass = getSymbolClass(iconName);
  if (iconName === 'notification') {
    return (
      <EnvelopeSymbolContainer color={color}>
        <BellWrapper>
          <div>
            <Icon name={symbolClass} size='large' />
            {
              notification && (
                <Label floating circular>{notification}</Label>
              )
            }
          </div>
        </BellWrapper>
      </EnvelopeSymbolContainer>
    );
  }

  if (iconName === 'envelope') {
    return (
      <EnvelopeSymbolContainer color={color}>
        <BellWrapper>
          <div>
            <Icon name={symbolClass} size='large' />
            {
              notification && (
                <Label floating circular>{notification}</Label>
              )
            }
          </div>
        </BellWrapper>
      </EnvelopeSymbolContainer>
    );
  }

  if (iconName === 'comment' || iconName === 'github') {
    return (
      <SymbolContainer gray hasBorder={hasBorder}>
        <Icon name={symbolClass} size='large' />
      </SymbolContainer>);
  }

  if (iconName === 'check') {
    return (
      <CheckSymbolContainer hasBorder={hasBorder} color={color}>
        <Icon name={symbolClass} size='large' />
      </CheckSymbolContainer>
    );
  }

  if (iconName === 'arrowUp' || iconName === 'arrowDown') {
    return (
      <LoadSymbolContainer arrowUp={iconName === 'arrowUp'} hasBorder={hasBorder}>
        <Icon className={iconName} />
      </LoadSymbolContainer>
    );
  }

  return (
    <SymbolContainer hasBorder={hasBorder}>
      <Icon name={symbolClass} size='large' />
    </SymbolContainer>
  );
};


Symbol.defaultProps = {
  iconName: 'calendar',
  hasBorder: false
};



// WEBPACK FOOTER //
// ./src/uiStandard/event/symbol.js